<template>
    <div class="mt-2">
        <div>
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon class="white--text">
                        fa-car
                    </v-icon>
                    Assets
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <EditPersonAssetDialog />
                <AddPersonAssetDialog :person-id="personId" />
            </v-toolbar>
            <v-data-table
                :headers="assetTableHeaders"
                :items="personAssetListSorted"
                :sort-by.sync="sortBy"
                :sort-desc="true"
                class="elevation-1"
                v-if="person !== undefined"
            >
                <template
                    slot="item"
                    slot-scope="props"
                >
                    <tr>
                        <td class="text-xs-left">
                            {{props.item.ecsReferenceCode}}
                        </td>
                        <td class="text-xs-left">
                            {{props.item.serialNumber}}
                        </td>
                        <td class="text-xs-left">
                            <!--              <router-link-->
                            <!--                :to="{ name: 'manage asset', params: { assetId: props.item.assetId }}"-->
                            <!--                class="manageAssetLink"-->
                            <!--              >-->{{ props.item.description }}
                            <!--              </router-link>-->
                        </td>
                        <td>
                            {{ props.item.assetType.name }}
                        </td>
                        <td
                            class="d-sm-table-cell text-xs-left"
                        >
                            {{ props.item.acquisitionDate | formatDate}}
                        </td>
                        <td
                            class="d-sm-table-cell text-xs-left"
                        >
                            {{ props.item.warrantyExpiryDate | formatDate}}
                        </td>
                        <td>
                            {{ props.item.cost }}
                        </td>
                        <td>
                            {{ props.item.currency != null ? props.item.currency.name : "" }}
                        </td>
                        <td>
                            {{ props.item.comments }}
                        </td>
                        <td>
                            {{ props.item.assetStatus.name }}
                        </td>
                        <td
                            class="justify-center layout px-0"
                        >
                            <v-icon
                                @click="editItem(props.item)"
                                class="mr-2"
                                small
                                style="display: inline-flex;"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                @click="deleteItem(props.item)"
                                small
                                style="display: inline-flex;"
                            >
                                delete
                            </v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import {DELETE_PERSON_ASSET_BY_PERSON_ID, FETCH_PERSON_ASSET_LIST_BY_ID, UPDATE_PERSON_ASSET} from "@/store/person_asset/actions";
    import {LOAD_PERSON_ASSET_TO_EDIT, RESET_DEFAULT_ASSET_TO_EDIT, TOGGLE_EDIT_PERSON_ASSET_DIALOG, UPDATE_NEW_PERSON_ASSET} from "@/store/person_asset/mutations";
    import EditTableFunctions from '../editTableFunctions';
    import AddPersonAssetDialog from "./AddPersonAssetDialog";
    import EditPersonAssetDialog from "./EditPersonAssetDialog";

    export default {
        name: "PersonAssetsTable",

        components: {AddPersonAssetDialog, EditPersonAssetDialog},

        mixins: [
            EditTableFunctions,
        ],

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                idName: 'assetId',
                dialog: false,
                assetTableHeaders: [
                    {text: 'ECS Reference Code', value: 'ecsReferenceCode'},
                    {text: 'Serial Number', value: 'serialNumber'},
                    {
                        text: 'Description',
                        align: 'left',
                        value: 'description',
                    },
                    {text: 'Asset Type', value: 'assetType'},
                    {text: 'Acquisition Date', value: 'acquisitionDate'},
                    {text: 'Warranty Expiry Date', value: 'warrantyExpiryDate'},
                    {text: 'Cost', value: 'cost'},
                    {text: 'Currency', value: 'currencyName'},
                    {text: 'Comments', value: 'comments'},
                    {text: 'Status', value: 'assetStatus' },
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                sortBy: 'startDate',
                rowsPerPageItems: [10, 20, 50, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],
                pagination: {
                    rowsPerPage: 10
                },
                editedId: -1,
            }
        },

        computed: {

            ...mapGetters(
            [
                "person",
                "personAssetListSorted",
                "employmentTypeList",
                "assetTypeList",
                "getAssetTypeNameById",
                "getCurrencyNameById",
                "assetStatusList",
                "getAssetStatusNameById",
            ]
            )
        },

        mounted() {
            if (this.personId) {
                // this.fetchAllTableItems();
                // this.fetchAssetTypeList();
                // this.fetchAssetStatusList();
            }
        },

        methods: {
            ...mapActions({
                fetchTableList: FETCH_PERSON_ASSET_LIST_BY_ID,
                updateTableItemRecord: UPDATE_PERSON_ASSET,
                deleteTableItem: DELETE_PERSON_ASSET_BY_PERSON_ID,
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_ASSET_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_ASSET_TO_EDIT,
                updateTableItemToEdit: UPDATE_NEW_PERSON_ASSET,
                resetEditItemToDefault: RESET_DEFAULT_ASSET_TO_EDIT,
            })
        },
    }
</script>

<style scoped>
</style>
